import { ReactNode, useMemo } from 'react'
import L2Erf from '../l2/L2Erf'
import { Concept } from '@fusion-advantage/formlib'

interface L3ErfProps {
	controlTitleConcepts: Concept[]
	contentTitles?: string[]
	children?: ReactNode
}

const L3Erf = ({controlTitleConcepts = [], contentTitles, children}: L3ErfProps) => {
	const controlTitles = useMemo(() => {
		return controlTitleConcepts.map(concept => concept.title || '')
	}, [controlTitleConcepts])
	return (
		<L2Erf
			controlTitles={controlTitles}
			contentTitles={contentTitles}
			children={children}
		/>
	)
}

export default L3Erf
